export const CYCLE_TEXT_INFO = 'Cyclescheme is available during checkout';
export const CYCLE_HEAD_TEXT = 'Leasing';
export const CYCLE_MAIN_TITLE = 'Cyclescheme';
export const CYCLE_DESCRIPTION = 'Cyclescheme is an employee benefit that can save you between 23-39% on a new Yamaha eBike and accessories';
export const CYCLE_BILLING_OUTSIDE = "Cyclescheme payment won't be available at checkout as your Billing address is outside of UK";
export const CYCLE_NOT_ELIGIBLE = 'Some products in the cart are not eligible for Cyclescheme payment option';
